import {Alert, alert} from "./alert/AlertComponent";
import {alertList, AlertList} from "./alert-list/TradingAlertListComponent";

import Dialog from "./alert-dialog";

export default function(parentDir: string): string {

    const rootDir = `${parentDir}/components`;

    return angular.module("tfApp.trading-alerts.components", [Dialog(rootDir)])
                  .component(Alert, alert(rootDir))
                  .component(AlertList, alertList(rootDir))
                  .name;
}
